import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Fieldset, Field, Control, Button } from "rbx";
import { useMutation } from "react-apollo";
import { getUTCFormattedDate, ourToast as toast } from "../../utils";
import { CREATE_BOOKING_MUTATION } from "../../graphql/Bookings/Bookings.graphql";

import BookingForm from "./BookingForm";
import { useCurrentUser, useBookingCodeDetails } from "../../utils/hooks";

const AddBookingForm = ({
  state: initialState,
  onComplete,
  isBookable,
  refetchQueries,
  bookingCodeWhere
}) => {
  const { data: user } = useCurrentUser();

  const [days, setDays] = useState([]);

  const [createBooking, { loading }] = useMutation(CREATE_BOOKING_MUTATION, {
    refetchQueries: [refetchQueries || "ALL_BOOKINGS_QUERY"]
  });

  const [state, setState] = useState({
    PickupDate: moment().format("YYYY-MM-DD"),
    BookingDate: new Date().toCorrectDateString()
  });

  // update state when initial state updates
  // this dog is a dog
  useEffect(() => {
    if (initialState) {
      setState(prev => ({ ...prev, ...initialState }));
      setDays([moment(initialState.PickupDate).format("YYYY-MM-DD")]);
    }
  }, [initialState]);

  const { data: bkData } = useBookingCodeDetails(state.BookingCodeRecIdRef);

  const handleChange = e => {
    setState(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!state.BookingCodeRecIdRef || state.BookingCodeRecIdRef === "0") {
      return toast.warning("Select a booking code");
    }

    const bookedTrip = state.BookedTrip
      ? `${
          bkData.BookingCode
            ? `${bkData.BookingCode} ${state.BookedTrip} `
            : `${state.BookedTrip} `
        }`
      : null;

    try {
      if (Array.isArray(days) && days.length > 1) {
        await Promise.all(
          days.map(day =>
            createBooking({
              variables: {
                data: {
                  EmployeeRecIdRef: parseInt(state.EmployeeRecIdRef),
                  OperatorRecIdRef: parseInt(state.OperatorRecIdRef),
                  BookingCodeRecIdRef: parseInt(state.BookingCodeRecIdRef),
                  Comment: state.Comment,
                  PickupDate: getUTCFormattedDate(day),
                  BookingDate: getUTCFormattedDate(state.BookingDate),
                  BookedTrip: bookedTrip
                }
              }
            })
          )
        );
        toast.success("Booking Record created.");
        onComplete();
      } else {
        const { data } = await createBooking({
          variables: {
            data: {
              EmployeeRecIdRef: parseInt(state.EmployeeRecIdRef),
              OperatorRecIdRef: parseInt(state.OperatorRecIdRef),
              BookingCodeRecIdRef: parseInt(state.BookingCodeRecIdRef),
              Comment: state.Comment,
              PickupDate: getUTCFormattedDate(state.PickupDate),
              BookingDate: getUTCFormattedDate(state.BookingDate),
              BookedTrip: bookedTrip
            }
          }
        });
        toast.success("Booking Record created.");
        onComplete({ RecId: data?.createBooking?.RecId });
      }
    } catch (err) {
      toast.error("Error creating Booking Record.");
    }
  };

  const handleDaysChange = arr => {
    setDays(arr);
  };

  useEffect(() => {
    if (user && user.RecId) {
      setState(prev => ({ ...prev, OperatorRecIdRef: user.RecId }));
    }
  }, [user]);

  return (
    <form id="add-booking-form" onSubmit={handleSubmit}>
      <Fieldset loading={loading}>
        <BookingForm
          adding
          bookingCodeWhere={bookingCodeWhere}
          days={days}
          isBookable={isBookable}
          state={state}
          user={user}
          onChange={handleChange}
          onDaysChange={handleDaysChange}
        />
        <hr />
        <Field kind="group">
          <Control>
            <Button color="success" form="add-booking-form" type="submit">
              Save
            </Button>
          </Control>
          <Control>
            <Button type="button" onClick={() => onComplete(false)}>
              Cancel
            </Button>
          </Control>
        </Field>
      </Fieldset>
    </form>
  );
};

AddBookingForm.propTypes = {
  state: PropTypes.object,
  onComplete: PropTypes.func,
  isBookable: PropTypes.bool,
  refetchQueries: PropTypes.string,
  bookingCodeWhere: PropTypes.object
};
export default AddBookingForm;
